// extracted by mini-css-extract-plugin
export var deliveryRow = "_sd-a";
export var fixedHeight = "_sd-4";
export var freightLogo = "_sd-9";
export var fullWidth = "_sd-3";
export var priceColumn = "_sd-5";
export var radioSelected = "_sd-7";
export var radioUnselected = "_sd-6";
export var selectedOption = "_sd-2";
export var selectedOptionContainer = "_sd-1";
export var selection = "_sd-0";
export var tallSkeletonText = "_sd-8";